import PreviewPlayButton from '#/components/Form/PreviewPlayButton/PreviewPlayButton';
import useDeviceId from '#/hooks/useDeviceId';
import useProtectedSpotify from '#/hooks/useProtectedAxios';
import ApiManager from '#/services/api/ApiManager';
import { spotifyApiConfig } from '#/utils/constants';
import React, {
  HTMLAttributes,
  ImgHTMLAttributes,
  MouseEvent,
  useState,
} from 'react';

interface IProperties {
  image?: ImgHTMLAttributes<HTMLImageElement>['src'];
  name?: string;
  type?: string;
  releaseYear?: number;
  loading?: boolean;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
  uri?: string;
}

const TopItemPreview = (properties: IProperties) => {
  const { image, name, type, releaseYear, loading, onClick, uri } = properties;
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => setHover(true);

  const handleMouseLeave = () => setHover(false);

  const { retrieveDeviceId } = useDeviceId();

  const protectedSpotify = useProtectedSpotify();

  const handleClickPlay = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    const apiManager = new ApiManager(spotifyApiConfig, protectedSpotify);

    const uriType = uri?.split(':')[1];

    const response = await apiManager.replaceEntity(
      'playerPlay',
      '',
      {
        context_uri: uriType === 'track' ? undefined : uri,
        uris: uriType === 'track' ? [uri] : undefined,
      },
      {
        device_id: retrieveDeviceId(),
      }
    );
    if ('error' in response) {
      // TODO: handle error
      // eslint-disable-next-line no-console
      console.log('Cant reproduce');
    }
  };

  return (
    <div
      className=" aspect-[206/284] p-4 bg-theme-dark-gray rounded-md shadow-theme-darker-gray shadow-lg transition-colors duration-300 hover:cursor-pointer hover:bg-theme-gray"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {loading ? (
        <>
          <div className="w-full aspect-square rounded-md mb-4 shadow-theme-darker-gray shadow-lg bg-theme-gray animate-pulse" />
          <div className=" w-5/6 rounded-full h-6 mb-1 animate-pulse bg-theme-gray" />
          <div className=" w-2/3 rounded-full h-5 animate-pulse bg-theme-gray" />
        </>
      ) : (
        <>
          <div className="relative aspect-square mb-4">
            <img
              className=" h-full w-full rounded-md object-cover shadow-theme-darker-gray shadow-lg"
              src={image}
              alt=""
              loading="lazy"
            />
            <PreviewPlayButton hover={hover} onClick={handleClickPlay} />
          </div>
          <span className=" block text-theme-white font-bold mb-1 one-line-text">
            {name}
          </span>
          <span className="text-sm text-theme-light-gray">
            {releaseYear}
            {type ? ` • ${type}` : ''}
          </span>
        </>
      )}
    </div>
  );
};

export default TopItemPreview;
